import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class TaxObligationService {
  private url: string = 'tax_obligations';

  constructor(private httpClient: HttpClientService) {}

  createPayment(checks: Array<any>): Promise<any> {
    return this.httpClient.post(`${this.url}/create_payment.json`, { checks: checks });
  }

  index(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`);
  }

  newPayment(tax_ids: Array<number>, tax_obligation_ids: Array<number>): Promise<any> {
    return this.httpClient.post(`${this.url}/new_payment.json`, { tax_ids: tax_ids, tax_obligation_ids: tax_obligation_ids });
  }
}
